<div class="building-list">
  <div class="header mt-1">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor mb-5"
        *ngIf="stepper > 1"
        (click)="!toggleFormUnit ? navigateBack() : resetToggleFormState()"
      />

      <div class="text-center">
        <h4 class="mb-4">
          <span> {{ formGroupUserDetail?.value?.firstName }} </span>

          <span> {{ formGroupUserDetail?.value?.lastName }} </span>
        </h4>
        <h1 class="modal-title mtm-10 mb-0">
          {{ 'USER_ADD_USER' | translate }}
        </h1>
      </div>

      <!-- dynamic back button render -->
      <ng-content select="[backButton]"></ng-content>
    </div>

    <div class="d-flex pt-3">
      <h2 class="heading1 m-auto">
        {{ 'ASSIGN_ACCESS' | translate }}
      </h2>
    </div>
    <ng-container *ngIf="!toggleFormUnit">
      <p class="m-auto text-center px-55 pt-3">
        {{ 'BUILDING_GRAND_ACCESS_TO_USER' | translate }}
      </p>
      <p class="m-auto text-center">
        {{ 'BUILDING_START_BY_SELECTING_BUILDING' | translate }}
      </p>
    </ng-container>
  </div>

  <!-- step form start -->
  <ng-container *ngIf="!toggleFormUnit">
    <div
      *ngIf="noneSelected && submited"
      class="alert alert-danger my-2 text-center"
      role="alert"
    >
      {{ 'BUILDING_IS_REQUIRED' | translate }}
    </div>
    <form
      [formGroup]="formGroup"
      [ngClass]="{ 'pt-3': !(formInstance?.entities?.errors && submited) }"
      tabindex="0"
      (keyup.enter)="submit()"
      #buildingListing
      novalidate
    >
      <div
        class="listing"
        [ngClass]="
          !(formInstance?.entities?.errors && submited)
            ? 'no-error'
            : 'has-error'
        "
      >
        <!-- error no building  start-->
        <ng-container *ngIf="!buildingList?.length">
          <div
            class="d-flex flex-column justify-content-center align-items-center h-100"
          >
            <div
              class="text-container d-flex flex-column justify-content-center align-items-center"
            >
              <div class="icon-container">
                <img src="assets/svg/ico-building-gray.svg" class="home-icon" />
              </div>
              <div class="text-center mt-3">
                <p>{{ 'NO_BUILDING_IN_THIS_SITE' | translate }}</p>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- error no building  end -->

        <div class="scroll-container">
          <div class="overflow-y">
            <ng-container
              *ngFor="
                let building of buildingList | sortBy : 'buildingName' : 'asc';
                let i = index
              "
            >
              <div
                class="form-group rounded-top form-container"
                [id]="building.buildingId"
              >
                <mat-form-field
                  appearance="fill"
                  class="w-100 building-list-container primary-input bottom-zero padding-top-balance middle"
                >
                  <div
                    class="d-flex list-box full pointer-cursor"
                    (click)="addBuildingUnit(building)"
                  >
                    <span class="align-self-center">
                      <img
                        src="/assets/svg/ico-building-with-black-circle.svg"
                        alt="ico-building-with-black-circle"
                        class="left-icon"
                      />
                    </span>
                    <span class="title bold col-5 pt-3">
                      <app-with-tooltip [showHelpCursor]="true">
                        {{ building?.buildingName }}
                      </app-with-tooltip>
                    </span>

                    <span
                      class="col-4 selected-value-container align-self-center"
                    >
                      <span
                        class="selected-value align-self-center"
                        *ngIf="building?.count > 0"
                      >
                        {{ building?.count }}
                      </span>
                      <span class="btn-not-text col-5">
                        <button class="icon-button" type="button">
                          <img
                            class="icon"
                            src="/assets/svg/ico-chevron-forward-outline.svg"
                          />
                        </button>
                      </span>
                    </span>
                  </div>

                  <input
                    matInput
                    [placeholder]="'ACCESS_TIME_START_TIME' | translate"
                    formControlName="entities"
                    class="d-none"
                  />
                </mat-form-field>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 my-1 mt-3">
          <button
            class="btn btn-danger px-3 w-100 btn-submit"
            [disabled]="noneSelected || !buildingList?.length"
            type="submit"
            (click)="submit()"
          >
            {{ 'CONTINUE' | translate }}
          </button>
        </div>
      </div>
    </form>
  </ng-container>
  <!-- step form end -->

  <!-- step unit and accesspoint list start -->
  <ng-container *ngIf="toggleFormUnit">
    <ng-container *ngIf="floorUnits?.length || filterCount > 0">
      <div class="row justify-content-between mt-3">
        <app-search-field
          (searchCriteria)="searchUnitsEvent($event)"
          class="col-10"
        ></app-search-field>
        <span class="position-relative">
          <img
            class="col-auto ml-3 filter-icon"
            src="assets/svg/ico-filter-circle-outline-white.svg"
            (click)="onFilterUnit()"
          />
          <span class="mf-badge" *ngIf="filterCount !== 0">
            <span class="circle-content">
              {{ filterCount || "" }}
            </span>
          </span>
        </span>
      </div>

      <ng-container *ngIf="floorUnits?.length">
        <div
          class="form-group row form-container slide-toggle-primary first mb-1"
        >
          <div class="col-8 pt-2">
            <div class="col-8 title bold">
              <app-with-tooltip [showHelpCursor]="true">
                {{ selectedBuilding?.buildingName }}
              </app-with-tooltip>
            </div>
          </div>
          <div class="col-4 d-flex align-items-center justify-content-end"
          class="col-4 d-flex align-items-center justify-content-end"
          (keyup.enter)="addUnit()"
          (keydown)="$event.preventDefault()"
          >
            <span class="text-nowrap mr-2 mt-2">{{ 'SELECT_ALL' | translate }}</span>
            <mat-slide-toggle
              class="mat-toggle"
              color="primary"
              [(ngModel)]="markAll"
              (change)="markList()"
            >
            </mat-slide-toggle>
          </div>

        </div>
      </ng-container>
    </ng-container>

    <form
      [formGroup]="formGroup"
      (keyup.enter)="addUnit()"
      (keydown)="$event.preventDefault()"
      novalidate
    >
      <!-- error no floorUnits  start-->
      <ng-container *ngIf="!floorUnits?.length && filterCount === 0">
        <div class="listing unit-list unit-list-height my-67">
          <div
            class="d-flex flex-column justify-content-center align-items-center h-100"
          >
            <div
              class="text-container d-flex flex-column justify-content-center align-items-center"
            >
              <div class="icon-container">
                <img src="assets/svg/ico-default-home.svg" class="home-icon" />
              </div>
              <div class="text-center mt-3">
                <p>{{ 'NO_UNIT_IN_THIS_BUILDING' | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- error no floorUnits  end -->

      <div
        class="listing unit-list unit-list-height"
        *ngIf="floorUnits?.length > 0"
      >
        <div class="scroll-container">
          <div class="overflow-y">
            <ng-container
              *ngFor="
                let floorUnit of floorUnits | orderBy : ['floorName'];
                let i = index
              "
            >
              <ng-container
                *ngFor="
                  let unit of floorUnit
                    | orderBy : ['unitName', 'accessPointName']
                    | filterBy : ['unitName', 'accessPointName'] : searchUnit;
                  let j = index
                "
              >
                <ng-container *ngIf="j === 0">
                  <div class="row icon-container justify-content-left mb-1">
                    <img
                      src="assets/svg/ico-floor.svg"
                      class="home-icon col-1"
                    />
                    <h2 class="selected-floorName font-weight-bold ml-2">
                      {{ floorUnit.floorName }}
                    </h2>
                    <div class="col-5 px-2 mt-2 ml-auto text-right text">
                      <app-with-tooltip [showHelpCursor]="true">{{
                        floorUnit.wingName
                          ? floorUnit.wingName + " - " + ("WING" | translate)
                          : ""
                      }}</app-with-tooltip>
                    </div>
                  </div>
                </ng-container>
                <!-- For object contain Units start -->
                <ng-container *ngIf="unit?.unitId">
                  <div
                    class="form-group rounded-top form-container"
                    [attr.data-unitId]="unit?.unitId"
                    [attr.data-buildingId]="unit?.buildingId"
                    [attr.data-floorId]="unit?.floorId"
                    [class.disabled-click]="unit.alreadySelected"
                  >
                    <mat-form-field
                      appearance="fill"
                      class="w-100 building-list-container primary-input bottom-zero padding-top-balance middle"
                    >
                      <div
                        class="d-flex list-box full"
                        [class.selected-item]="unit.status"
                      >
                        <span>
                          <img
                            src="/assets/svg/ico-default-home-circle.svg"
                            alt="ico-building-with-black-circle"
                            class="left-icon"
                          />
                        </span>
                        <span
                          class="title bold"
                          [ngClass]="{
                            'pt-3': !unit?.alreadySelected
                          }"
                        >
                          <div class="col-8">
                            <app-with-tooltip [showHelpCursor]="true">
                              {{ unit?.unitName }}
                            </app-with-tooltip>
                            <ng-container *ngIf="unit?.alreadySelected">
                              <span class="description">
                                {{ 'ALREADY_SHARED_TEXT' | translate }}</span
                              >
                            </ng-container>
                          </div>
                        </span>
                        <span
                          class="selected-value-container checked-spacer m-auto"
                        >
                          <span class="selected-value time-right"> </span>
                          <span class="btn-not-text">
                            <button
                              class="icon-button-checked"
                              type="button"
                              (click)="updateUnitStatus(unit)"
                            >
                              <img
                                class="icon"
                                [src]="
                                  unit.status
                                    ? '/assets/svg/ico-checkmark-circle-outline.svg'
                                    : '/assets/svg/ico-circle.svg'
                                "
                              />
                            </button>
                          </span>
                        </span>
                      </div>
                    </mat-form-field>
                  </div>
                </ng-container>
                <!-- For object contain Units end -->

                <!-- For object contain AccessPoints start -->
                <ng-container *appHideAccess="commonAccessControl">
                  <ng-container *ngIf="unit?.accessPointId">
                    <div
                      class="form-group rounded-top form-container"
                      [attr.data-accessPointId]="unit?.accessPointId"
                      [attr.data-buildingId]="unit?.buildingId"
                      [attr.data-floorId]="unit?.floorId"
                      [class.disabled-click]="unit.alreadySelected"
                    >
                      <mat-form-field
                        appearance="fill"
                        class="w-100 building-list-container primary-input bottom-zero padding-top-balance middle"
                      >
                        <div
                          class="d-flex list-box full"
                          [class.selected-item]="unit.status"
                        >
                          <span>
                            <img
                              src="assets/images/accesspoint-icon.png"
                              alt="ico-building-with-black-circle"
                              class="left-icon"
                            />
                          </span>
                          <span
                            class="title bold"
                            [ngClass]="{
                              'pt-3': !unit?.alreadySelected
                            }"
                          >
                            <div class="col-8">
                              <app-with-tooltip [showHelpCursor]="true">
                                {{ unit?.accessPointName }}
                              </app-with-tooltip>
                            </div>
                            <ng-container *ngIf="unit?.alreadySelected">
                              <span class="description">{{
                                'ALREADY_SHARED_TEXT' | translate
                              }}</span>
                            </ng-container>
                          </span>

                          <span
                            class="selected-value-container checked-spacer m-auto"
                          >
                            <span class="selected-value time-right"> </span>
                            <span class="btn-not-text">
                              <button
                                class="icon-button-checked"
                                type="button"
                                (click)="updateUnitStatus(unit)"
                              >
                                <img
                                  class="icon"
                                  [src]="
                                    unit.status
                                      ? '/assets/svg/ico-checkmark-circle-outline.svg'
                                      : '/assets/svg/ico-circle.svg'
                                  "
                                />
                              </button>
                            </span>
                          </span>
                        </div>
                      </mat-form-field>
                    </div>
                  </ng-container>
                </ng-container>
                <!-- For object contain AccessPoints end -->
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>

      <ng-container *ngIf="!floorUnits?.length && filterCount > 0">
        <div class="my-154">
          <div
            class="d-flex flex-column justify-content-center align-items-center h-100"
          >
            <div
              class="text-container d-flex flex-column justify-content-center align-items-center"
            >
              <div class="icon-container">
                <img src="assets/svg/ico-default-home.svg" class="home-icon" />
              </div>
              <div class="text-center mt-3">
                <p>{{ 'NO_FLOORS_AVAILABLE_FOR_APPLIED_FILTER' | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="row">
        <div class="col-12 my-1">
          <button
            class="btn btn-danger px-3 w-100 btn-submit"
            type="button"
            (click)="addUnit()"
          >
            {{ 'CONTINUE' | translate }}
          </button>
        </div>
      </div>
    </form>
  </ng-container>
  <!-- step unit and accesspoint list end -->
</div>
